import clsx from 'clsx'

export default function TextInputField({
  id,
  label,
  value,
  onChange,
  placeholder,
  icon,
  type = 'text',
  autoComplete = 'off',
  disabled = false,
  trailingAction,
  name,
}) {
  return (
    <div className="space-y-2">
      <div className="flex items-end justify-between gap-4">
        <label
          htmlFor={id}
          className="block font-label text-[11px] font-semibold uppercase tracking-[0.18em] text-on-surface-variant"
        >
          {label}
        </label>
        {trailingAction}
      </div>

      <div className="relative">
        <input
          id={id}
          name={name || id}
          className={clsx(
            'h-14 w-full rounded-lg border-0 bg-surface-container-low px-4 text-sm text-on-surface placeholder:text-outline/60 transition-all',
            'focus:bg-surface-container-lowest focus:outline-none focus:ring-2 focus:ring-primary/40',
            disabled && 'cursor-not-allowed opacity-70'
          )}
          type={type}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder={placeholder}
          autoComplete={autoComplete}
          disabled={disabled}
        />
        {icon ? (
          <span
            className="material-symbols-outlined pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-[20px] text-outline/80"
            aria-hidden="true"
          >
            {icon}
          </span>
        ) : null}
      </div>
    </div>
  )
}
